import A from 'const/actionTypes'
import P from 'const/paramTypes'

export default (currentState = {}, action) => {
  let updatedState = Object.assign({}, currentState)

  switch (action.type) {
    case A.LOCATION_CHANGE:
      const pathname = action.payload.pathname

      const pathSegments = pathname.split('/').filter(path => path)
      const paramSegments = action.payload.query
      updatedState.previousRoute = updatedState.route
      updatedState.paramSegments = updatedState.paramSegments || {}

      for (let paramKey in paramSegments) {
        updatedState.paramSegments[P[paramKey]] = paramSegments[paramKey]
      }

      updatedState.route = pathSegments[0]
      if (pathSegments.length > 1) {
        updatedState.route = pathSegments.join('/')
      }
      break
    case A.UPDATE_ROUTE_PARAMS:
      updatedState = Object.assign({}, updatedState, action.params)
      break
  }

  return updatedState
}



// WEBPACK FOOTER //
// ./src/app/reducers/routeParams.js